import { Skeleton } from 'ui/skeleton';
import {
  StyledCopyAssistDropdownHeader,
  TextSkeletonWrapper,
} from 'modules/ai/copyAssist/components/dropdown/styles';

interface CopyAssistDropdownHeaderProps {
  isLoading: boolean;
  copyType: string;
  originalCopy: string;
}

export const CopyAssistDropdownHeader = ({
  isLoading,
  copyType,
  originalCopy,
}: CopyAssistDropdownHeaderProps) => {
  return (
    <StyledCopyAssistDropdownHeader data-test="copy-assist-dropdown-header">
      {isLoading ? (
        <TextSkeletonWrapper data-test="copy-assist-loading-header-section">
          <Skeleton height={16} width={300} isRound />
        </TextSkeletonWrapper>
      ) : (
        <>
          <span>Original {copyType}:</span> {originalCopy}
        </>
      )}
    </StyledCopyAssistDropdownHeader>
  );
};
